import React, { useState, useRef, useEffect } from 'react';
import c from 'classnames';
const Tooltip = _ref => {
  let {
    title,
    className,
    tooltipId,
    onOpen,
    onClose,
    trigger
  } = _ref;
  const targetRef = useRef(null);
  const targetIcon = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const [positionY, setPositionY] = useState('up');
  const [positionX, setPositionX] = useState('center');
  const [timeoutId, setTimeoutId] = useState(null);
  const TOOLTIP_CLOSING_DELAY = 1500;
  const triggerTooltipOpen = () => {
    setIsOpen(true);
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
    if (onOpen) {
      onOpen();
    }
  };
  const triggerTooltipClose = () => {
    setTimeoutId(setTimeout(() => {
      setIsOpen(false);
      if (onClose) {
        onClose();
      }
    }, TOOLTIP_CLOSING_DELAY));
  };
  useEffect(() => {
    if (targetRef.current && targetIcon.current) {
      const {
        y,
        x,
        right,
        bottom
      } = targetRef.current.getBoundingClientRect();
      const {
        width
      } = targetIcon.current.getBoundingClientRect();
      const remainderRight = window.innerWidth - right;
      const remainderBottom = window.innerHeight - bottom;
      const TOOLTIP_ARROW_WIDTH = 14;
      if (y < 0) {
        setPositionY('down');
      }
      if (x < 0) {
        setPositionX('left');
        setOffset(TOOLTIP_ARROW_WIDTH - width / 2);
      }
      if (remainderRight < 0) {
        setPositionX('right');
        setOffset(TOOLTIP_ARROW_WIDTH - width / 2);
      }
      if (remainderBottom < 0) {
        setPositionY('up');
      }
    }
  }, []);
  const classNames = c('Tooltip', 'icon', 'icon-info', 'Tooltip--button', className);
  const tooltipWidgetClasses = c('tooltip', 'tooltip-widget', "tooltip--".concat(positionY), "tooltip--".concat(positionX), {
    'tooltip--show': isOpen
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "tooltip--container"
  }, trigger ? trigger({
    ref: targetIcon,
    onMouseEnter: triggerTooltipOpen,
    onFocus: triggerTooltipOpen,
    onMouseLeave: triggerTooltipClose,
    onBlur: triggerTooltipClose,
    onKeyDown: e => {
      if (e.key === 'Escape' && isOpen === true) {
        setTimeoutId(setTimeout(() => {
          setIsOpen(false);
        }, 0));
      }
    }
  }) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    ref: targetIcon,
    className: classNames,
    "aria-describedby": tooltipId,
    onMouseEnter: triggerTooltipOpen,
    onFocus: triggerTooltipOpen,
    onMouseLeave: triggerTooltipClose,
    onBlur: triggerTooltipClose,
    onKeyDown: e => {
      if (e.key === 'Escape' && isOpen === true) {
        setTimeoutId(setTimeout(() => {
          setIsOpen(false);
        }, 0));
      }
    }
  }, "Meer informatie"), /*#__PURE__*/React.createElement("div", {
    ref: targetRef,
    className: tooltipWidgetClasses,
    style: {
      left: "-".concat(offset, "px"),
      right: "-".concat(offset, "px")
    },
    onMouseEnter: triggerTooltipOpen,
    onFocus: triggerTooltipOpen,
    onMouseLeave: triggerTooltipClose,
    onBlur: triggerTooltipClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip__inner",
    id: tooltipId
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "tooltip__arrow"
  }))));
};
export default Tooltip;